<div class="content">
  <!-- Close Button -->
  <button class="close" mat-icon-button (click)="onCancel()">
    <mat-icon svgIcon="close-icon"></mat-icon>
  </button>

  <!-- Header -->
  <div class="header">
    <app-page-subheader
      class="col-12"
      icon="upgrade"
      [title]="data.title"
    ></app-page-subheader>
  </div>

  <!-- Message -->
  <div class="message" [innerHTML]="data.message"></div>

  <!-- Promo Code Section -->
  <div class="promo-section">
    <p class="section-label">
      <mat-icon class="label-icon">local_offer</mat-icon>
      {{ 'COMPANY.PROMO_CODE_OPTIONAL' | translate }}
    </p>

    <div class="promo-input-row">
      <mat-form-field class="promo-field">
        <mat-label>{{ 'COMPANY.PROMO_CODE' | translate }}</mat-label>
        <input
          matInput
          [(ngModel)]="promotionCode"
          name="promotionCode"
          placeholder="{{ 'COMPANY.ENTER_CODE' | translate }}"
          (ngModelChange)="onPromoCodeChange($event)"
        />
        <mat-icon matSuffix *ngIf="isPromoApplied" class="success-icon"
          >check_circle</mat-icon
        >
      </mat-form-field>
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="onApplyPromo()"
        class="apply-btn"
      >
        <span *ngIf="!isValidatingPromo">{{
          'GENERAL.APPLY' | translate
        }}</span>
        <span *ngIf="isValidatingPromo">{{
          'GENERAL.VALIDATING' | translate
        }}</span>
      </button>
    </div>

    <!-- Success Message -->
    <div *ngIf="isPromoApplied && discountPercentage" class="success-message">
      <div class="success-header">
        <mat-icon class="success-message-icon">check_circle</mat-icon>
        <div class="success-text">
          <span class="success-title">{{
            'COMPANY.PROMO_APPLIED' | translate
          }}</span>
          <span class="success-discount"
            >{{ discountPercentage }}% {{ 'COMPANY.OFF' | translate }}</span
          >
        </div>
      </div>

      <!-- Amount Breakdown -->
      <div *ngIf="data.amount && data.currency" class="amount-breakdown">
        <div class="amount-row">
          <span class="amount-label">{{ 'COMPANY.TOTAL' | translate }}:</span>
          <span class="amount-value original"
            >{{
              data.amount
                | upperNumber: { precision: 2 }
                | currencyNumberTranslate
            }}
            {{
              data.currency === 'SAR'
                ? ('GENERAL.SAR' | translate)
                : data.currency === 'USD'
                  ? ('GENERAL.USD' | translate)
                  : ('GENERAL.AED' | translate)
            }}</span
          >
        </div>
        <div class="amount-row discount-row">
          <span class="amount-label"
            >{{ 'COMPANY.DISCOUNT_AMOUNT' | translate }}:</span
          >
          <span class="amount-value discount"
            >-{{
              discountAmount
                | upperNumber: { precision: 2 }
                | currencyNumberTranslate
            }}
            {{
              data.currency === 'SAR'
                ? ('GENERAL.SAR' | translate)
                : data.currency === 'USD'
                  ? ('GENERAL.USD' | translate)
                  : ('GENERAL.AED' | translate)
            }}</span
          >
        </div>
        <div class="amount-row final-row">
          <span class="amount-label final"
            >{{ 'COMPANY.TOTAL_AFTER_DISCOUNT' | translate }}:</span
          >
          <span class="amount-value final"
            >{{
              finalAmount
                | upperNumber: { precision: 2 }
                | currencyNumberTranslate
            }}
            {{
              data.currency === 'SAR'
                ? ('GENERAL.SAR' | translate)
                : data.currency === 'USD'
                  ? ('GENERAL.USD' | translate)
                  : ('GENERAL.AED' | translate)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="actions">
    <button class="secondary-button" type="button" (click)="onCancel()">
      {{ data.cancelLabel }}
    </button>
    <button
      class="primary-button"
      type="button"
      (click)="onConfirm()"
      [disabled]="isValidatingPromo"
    >
      {{ data.confirmLabel }}
    </button>
  </div>
</div>
